import React from 'react';
import { useState } from 'react';
import ProviderSignupForm from './components/ProviderSignupForm';
import { useHistory } from 'react-router-dom';
import AuthFormPage from './components/AuthFormPage';
import { AuthAPI } from '../../api';

const DEFAULT_ERROR_MESSAGE = 'An error occurred creating your account.  Please try again later.';

const ProviderSignupPage = () => {
  const history = useHistory();
  const [busy, setBusy] = useState(false);
  const [signupError, setSignupError] = useState();

  const onComplete = async (args) => {
    try {
      setBusy(true);
      await AuthAPI.providerSignup(args);
      setBusy(false);
      history.push('/signup/confirm', {email: args.email});
    } catch (err) {
      setBusy(false);
      console.error(err);  // eslint-disable-line no-console
      const message = (err.body && err.body.message) ? err.body.message : DEFAULT_ERROR_MESSAGE;
      setSignupError(message);
      history.replace('#1');
    }
  };

  return (
    <AuthFormPage title="Clickability Provider Signup">
      <ProviderSignupForm
        loginLink="/providers/login"
        busy={busy}
        onComplete={onComplete}
        signupError={signupError}
      />
    </AuthFormPage>
  );
};

export default ProviderSignupPage;
